import {
	Component,
	ElementRef,
	inject,
	OnInit,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
import {
	ActivatedRoute,
	Router
} from '@angular/router';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LPService} from "../../shared/services/lp.service";
import {AppConfigService} from "../../shared/services/config/app-config.service";
import {environment} from "@env/environment";

export interface FaqItem {
	question: string;
	answer: string;
}

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
	@ViewChild('popupContent', {static: true}) popupContent: ElementRef | undefined;
	@ViewChild('faqContent', {static: true}) faqContent: ElementRef | undefined;
	loanPurpose: string = 'CC';
	merchantId: any;
	requestedCardType: string | undefined;
	creditCards: any;
	personalCC: any = [];
	allBusinessCC: any = []
	allBusinessCCCharge: any = [];
	businessCC: any = []
	optionModel: any;
	skeletonCards: any = [1, 2, 3];
	activeNavTab: number = 1;
	showRewardsDisclosure: boolean = false;
	private modalService = inject(NgbModal);
	appConfig = AppConfigService.config;
    public hasCliSubProduct: boolean = false;
	bannerData: any = null;
	faqItems: FaqItem[] = [
		{
			question: 'What does it mean to be pre-qualified?',
			answer: 'Pre-qualification is a way to see personalized credit card offers available to you based on information you provide on the prequalification form, without affecting your credit score. These credit card offers shown are based on your personal and financial information entered and are not a guarantee of approval.'
		},
		{
			question: 'Will my credit score be affected by checking to see if I’m pre-qualified?',
			answer: 'Completing the prequalification form involves a “soft inquiry” from the credit bureau which does not affect your credit score.'
		},
		{
			question: 'Do pre-qualification offers guarantee a credit card account?',
			answer: 'With pre-qualification, we can review your creditworthiness with standard financial information. However, this does not guarantee approval.'
		},
		{
			question: 'What happens after I see pre-qualified credit card offers?',
			answer: 'After viewing the offers you pre-qualify for, you can choose if you want to apply. You will be able to see rates and card details before applying. When you apply, you will need to share additional financial information which results in a hard inquiry on your credit.'
		},
		{
			question: 'What will you do with my personal information such as my Social Security Number?',
			answer: 'Your Social Security Number is used for identification purposes during the pre-qualification process without affecting your credit score. We will use the information you provide in accordance with our privacy notice.'
		}
	];
	preFooterIcons: any[] = [];

	constructor(private activatedRoute: ActivatedRoute,
		private lpService: LPService,
		private router: Router) {
		this.creditCards = [];
	}

	ngOnInit() {
		// Preload images to prevent flickering or blank space on banner area
		const img = new Image();
		const img2 = new Image();
		img.src = `${environment.s3Url}images/${environment.institutionCode}/lp-banner-personal-bg.jpg`;
		img2.src  = `${environment.s3Url}images/${environment.institutionCode}/lp-banner-business-bg.jpg`;

		this.setBannerData();
		this.updatePreFooterIcons();

		this.activatedRoute.queryParams.subscribe(params => {
			if (params['type']) {
				this.requestedCardType = params['type'].toLowerCase();
			}
		});

		this.activatedRoute.params.subscribe((params: any) => {
			this.merchantId = params['merchantId'];
			if (this.merchantId && this.merchantId.length > 0) {
				//  this.getPartnerDetails();
				this.getOfferDetails();

			}
		});
		if (!this.merchantId) {
			this.activatedRoute.queryParams.subscribe(params => {
				this.merchantId = params['merchantId'];
				if (this.merchantId && this.merchantId.length > 0) {
					//  this.getPartnerDetails();
					this.getOfferDetails();

				}
			});
		}

		if (!this.merchantId) {
			this.router.navigate(['/error']);
		}
	}

	setBannerData() {
		if (this.loanPurpose === 'CC') {
			this.bannerData = {
				class: 'banner',
				bgImage: `url(${environment.s3Url}images/${environment.institutionCode}/lp-banner-personal-bg.jpg)`,
				title: this.appConfig?.homepage?.homeCardTitle ?? 'Credit Cards for <br> Every Lifestyle.',
				subtitle: this.appConfig?.homepage?.homeCardSubtitle ?? 'See your card offers with <br> no impact to your credit',
				showButtons: true,
				button1: this.appConfig?.homepage?.homeButton1Text ?? 'See if I Pre-Qualify',
                button2: this.appConfig.hideHowItWorksButton ? null : 'How it Works',
                button3: 'Request Credit Increase'
			};
		} else if (this.loanPurpose === 'BCC' || this.loanPurpose === 'BCC_CHARGE') {
			this.bannerData = {
				class: 'business-banner',
				bgImage: `url(${environment.s3Url}images/${environment.institutionCode}/lp-banner-business-bg.jpg)`,
				title: 'Credit Cards for <br> All your Business <br> Needs.',
				subtitle: 'Find the best card <br> for your business.',
				showButtons: true,
                button3: 'Request Credit Increase',
			};
		} else {
			this.bannerData = null;
		}
	}


	gotoCXUrl() {
		if (this.merchantId) {
			let url = `${environment.cxUrl}/product/${this.loanPurpose}?merchantId=${this.merchantId}`;
			window.open(url, "_blank");
		}
	}

    gotoCXUrlForCliSubProduct() {
        if (this.merchantId) {
            let url = `${environment.cxUrl}/product/cli?merchantId=${this.merchantId}`;
            window.open(url, "_blank");
        }
    }

	getOfferDetails(): void {
		// Make the HTTP request with the authorization header
		this.lpService.getPartnerProducts(this.merchantId).subscribe({
			next: (response: any) => {
				if (response && Array.isArray(response) && response.length > 0) {
                    this.hasCliSubProduct = response.some(item => item.startsWith('CLI'));
					this.setCreditCards(response);
				} else {
					this.router.navigate(['/error']);
				}
			},
			error: (error) => {
				console.error('Error:', error);
			}

		});
	}

	createCard(config: any, key: string, merchantId: string, type?: string) {
		return {
			name: config[key]?.title || '',
			subTitle: config[key]?.subTitle || '',
			longInfo: config[key]?.longInfo || '',
			shortInfo: config[key]?.shortInfo || '',
			imageUrl: `${environment.s3Url}images/${environment.institutionCode}/${merchantId}_${key}.png`,
			id: key,
			type: config[key]?.type || type || '',
			hideFromLandingPage: config[key]?.hideFromLandingPage || false
		};
	}


	setCreditCards(subProducts: any) {
		const {CC, BCC, BCC_CHARGE} = this.appConfig;
		const configs = [
			{config: CC?.offerVariationDetails || {}, arr: this.personalCC},
			{config: BCC?.offerVariationDetails || {}, arr: this.allBusinessCC},
			{config: BCC_CHARGE?.offerVariationDetails || {}, arr: this.allBusinessCCCharge}
		];

		configs.forEach(({config, arr}) => {
			Object.keys(config).forEach(key => {
				if (subProducts.includes(key)) {
					const card = this.createCard(config, key, this.merchantId);
					// Only add card to array if it's not hidden from landing page
					if (!card.hideFromLandingPage) {
						arr.push(card);
					}
				}
			});
		});

		const hasPersonalCards = this.personalCC.length > 0;
		const hasBusinessCards = this.allBusinessCC.length > 0 || this.allBusinessCCCharge.length > 0;

		if (this.requestedCardType === 'business' && hasBusinessCards) {
			this.activeNavTab = 2;
			this.selectBusinessCardType();
		} else if (this.requestedCardType === 'personal' && hasPersonalCards) {
			this.activeNavTab = 1;
			this.setLoanPurpose('CC');
		} else if (hasPersonalCards) {
			this.activeNavTab = 1;
			this.setLoanPurpose('CC');
		} else if (hasBusinessCards) {
			this.activeNavTab = 2;
			this.selectBusinessCardType();
		}
	}

	setLoanPurpose(loanPurpose: string) {
		this.loanPurpose = loanPurpose;
		this.setBannerData();
		this.updatePreFooterIcons();
		this.showRewardsDisclosure = (loanPurpose === 'CC' ? this.personalCC : this.businessCC).filter((cc: any) => {
			return cc.name.toLowerCase().includes('rewards')
		}).length > 0;

	}

	selectBusinessCardType() {
		this.businessCC = [];

		if (this.appConfig.showBCCProductsFilter) {
			this.optionModel = this.modalService.open(this.popupContent, {
				centered: true,
				modalDialogClass: 'options-model-container',
				backdrop: 'static',
				keyboard: false
			});
			//this.setLoanPurpose('BCC');
		} else {
			this.updateAccountType('BCC');
		}
	}

	updateAccountType(accountType = 'BCC') {
		this.businessCC = accountType === 'BCC_CHARGE' ? this.allBusinessCCCharge : this.allBusinessCC

		this.setLoanPurpose(accountType);
		if (this.optionModel) {
			this.optionModel.close()
		}
	}

	openFAQModal() {
		this.optionModel = this.modalService.open(this.faqContent, {
			centered: true,
			modalDialogClass: 'faq-modal-container'
		});
	}

	get hasDynamicPreFooterIcons(): boolean {
		const images = this.appConfig?.preFooterIcons;
		return Array.isArray(images) && images.length > 0;
	}

	updatePreFooterIcons() {
		const icons = this.appConfig.preFooterIcons;
		if (Array.isArray(icons)) {
			this.preFooterIcons = icons;
		} else if (icons) {
			this.preFooterIcons = this.loanPurpose === 'CC' ? icons.personal : icons.business;
		}
	}
}

